import { useEffect, useRef } from 'react';

function useClickOutside<T extends HTMLElement>(callback: EventListener) {
  const ref = useRef<T>(null);
  const _callback = useRef(callback);
  _callback.current = callback;

  useEffect(() => {
    const target = ref.current;
    if (!target) return;

    const handler: EventListener = (e) => {
      if (!target.contains(e.target as Node)) _callback.current(e);
    };
    window.addEventListener('click', handler, true);
    return () => window.removeEventListener('click', handler, true);
  }, []);

  return ref;
}

export default useClickOutside;
